import { AddressState } from './types'
import { AsyncStateStatus } from '../root.types'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

const initialState: AddressState = {
    person: {
        status: AsyncStateStatus.INITIAL,
        data: []
    },
    company: {
        status: AsyncStateStatus.INITIAL,
        data: []
    },
    geometryPerson: {
        status: AsyncStateStatus.INITIAL,
        data: []
    },
    geometryCompany: {
        status: AsyncStateStatus.INITIAL,
        data: []
    }
}

export const addressSlice = createSlice({
    name: '@address',
    initialState,
    reducers: {
        addressPersonRequest: (state: Draft<AddressState>) => {
            state.person.status = AsyncStateStatus.LOADING
            state.geometryPerson = initialState.geometryPerson
        },
        addressPersonSuccess: (state: Draft<AddressState>, action: PayloadAction<{ data: any } >) => {
            state.person.status = AsyncStateStatus.SUCCESS
            state.person.data = action.payload.data
        },
        addressPersonFailure: (state: Draft<AddressState>) => {
            state.person.status = AsyncStateStatus.FAILURE
            state.person.data = []
        },
        addressCompanyRequest: (state: Draft<AddressState>) => {
            state.company.status = AsyncStateStatus.LOADING
            state.geometryCompany = initialState.geometryCompany
        },
        addressCompanySuccess: (state: Draft<AddressState>, action: PayloadAction<{ data: any } >) => {
            state.company.status = AsyncStateStatus.SUCCESS
            state.company.data = action.payload.data
        },
        addressCompanyFailure: (state: Draft<AddressState>) => {
            state.company.status = AsyncStateStatus.FAILURE
            state.company.data = []
        },
        addressPersonGeometryRequest: (state: Draft<AddressState>) => {
            state.geometryPerson.status = AsyncStateStatus.LOADING
            state.person = initialState.person
        },
        addressPersonGeometrySuccess: (state: Draft<AddressState>, action: PayloadAction<{ data: any } >) => {
            state.geometryPerson.status = AsyncStateStatus.SUCCESS
            state.geometryPerson.data = action.payload.data
        },
        addressPersonGeometryFailure: (state: Draft<AddressState>) => {
            state.geometryPerson.status = AsyncStateStatus.FAILURE
            state.geometryPerson.data = []
        },
        addressCompanyGeometryRequest: (state: Draft<AddressState>) => {
            state.geometryCompany.status = AsyncStateStatus.LOADING
            state.company = initialState.company
        },
        addressCompanyGeometrySuccess: (state: Draft<AddressState>, action: PayloadAction<{ data: any } >) => {
            state.geometryCompany.status = AsyncStateStatus.SUCCESS
            state.geometryCompany.data = action.payload.data
        },
        addressCompanyGeometryFailure: (state: Draft<AddressState>) => {
            state.geometryCompany.status = AsyncStateStatus.FAILURE
            state.geometryCompany.data = []
        },
        addressCancel: (state: Draft<AddressState>) => {
            state.person = initialState.person
            state.company = initialState.company
            state.geometryPerson = initialState.geometryPerson
            state.geometryCompany = initialState.geometryCompany
        },
    }
})


export const AddressActions = addressSlice.actions

export default addressSlice.reducer
